import logo from "../asset/Images/cryptocrispyLogo.png";
import styles from "../styles/pages/WelcomePage.module.css";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {getProfileData} from "../redux/profile/actions";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Welcome from "../ui/Welcome";

const WelcomePage = () => {
    const {
        main: {userData},
        profile: {profileData, loading, error},
    } = useSelector((state) => state);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        if (profileData?.user) {
            if (!profileData?.suggested_features) {
                navigate("/start-wizard");
            } else {
                navigate("/dashboard");
            }
        }
    }, [navigate, profileData]);

    useEffect(() => {
        if (
            userData?.email &&
            !loading &&
            !Object.keys(profileData).length &&
            !error
        ) {
            dispatch(
                getProfileData(
                    userData?.email,
                    userData?.["custom:custom_username"],
                    "fast",
                ),
            );
        }
    }, [profileData, loading, userData, dispatch, error]);

    return (
        <div className={styles.welcomeContainer}>
            {!error && (
                <Welcome/>
            )}
            {/*{error && <ErrorBox />}*/}
        </div>
    );
};

export default WelcomePage;
